<template>
    <div class="container-fluid" v-if="isDataReady">
        <v-title :lineage="[{'Segments':'segments'}]">
            {{ this.page | unKebabCase }}
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-segment'].isAllowed"
                    :to="{name: 'add-segment', params: {page: segmentCollection.activePage.name}}"
                    class="btn btn-link">Add Segment<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="tile">
            <r-tabs divided
                    ref="listTabs"
                    contentClass="no-padding"
                    @tab-selected="selectTab">
                <r-tab
                    v-for="(segmentPage, index) in segmentCollection.activePage.categories"
                    :to="{name: 'segment-management', params: {page: segmentCollection.activePage.name, category: segmentPage.name}}"
                    :key="index"
                    :name="segmentPage.label"
                    :value="segmentPage.name">
                    <div class="tile-content">
                        <segment-grid-group :category="segmentPage.name" :page="segmentCollection.activePage.name"/>
                    </div>
                </r-tab>
            </r-tabs>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import vTitle from '@/components/v-title';
    import {mapActions, mapGetters} from 'vuex';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import vAccordion from '@/components/v-accordion';
    import SegmentGridGroup from '@/modules/segments/components/segment-grid-groups';
    import SegmentDataModel from '@/common/models/segment-data-model';

    export default {
        name: 'segment-management',
        mixins: [LoadStateMixin],
        components: {
            vTitle,
            vAccordion,
            vIcon,
            SegmentGridGroup,
        },
        props: {
            page: {
                type: String,
                default: SegmentDataModel.Pages.lists,
            },
            category: {
                type: String,
                default: SegmentDataModel.Categories.customers,
            },
        },
        computed: {
            ...mapGetters({
                segmentCollection: 'segments/segmentCollection',
            }),
        },
        methods: {
            ...mapActions({
                fetchSegments: 'segments/fetch',
                fetchUsers: 'users/fetch',
                activateSegmentPage: 'segments/activateSegmentPage',
                activateSegmentCategory: 'segments/activateSegmentCategory',
            }),
            async fetchData() {
                await this.fetchSegments(this.$auth);
                if (this.$auth.users.read.isAllowed) {
                    await this.fetchUsers();
                }

                try {
                    this.activateSegmentPage(this.page);
                    this.activateSegmentCategory(this.category);
                } catch (err) {
                    // most likely an issue with the props being passed
                    this.$toast.negative('There was an issue while trying to access the management page.');
                    console.error(err);
                }
            },
            selectTab({value}) {
                this.activateSegmentCategory(value);
            },
        },
    };
</script>
